const ProgressBar = (props) => {
    const { bgcolor, completed } = props;
  
    const containerStyles = {
      height: 4,
      width: '100%',
      backgroundColor: "#e0e0de",
      borderRadius: 50,
      marginBottom: 20,
      flex: '0 0 100%',
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      borderRadius: 'inherit',
      textAlign: 'right'
    }
  
    const labelStyles = {
      padding: 2,
      color: 'black', 
      fontSize:'14px', 
      textAlign:'center',
      fontWeight:'bold',
    } 
  
    return (
      <div style={containerStyles}>
        <div style={fillerStyles}>
          <span ></span> 
        </div>
        <div style={labelStyles}>{`${completed}%`}</div>
      </div>
    );
  };
  
  export default ProgressBar;